import UseContext from "../../../../../../../hooks/useContext";
import useSlideOver from "../../../../../../../components/SlideOver/useSlideOver";
import useModal from "../../../../../../../components/modal/useModal";
import Badge from "../../../../../../../components/badge/badge";
import CopyToClipboard from "../../../../../../../components/copyToClipboard";
import { BanIcon, Dots, EyeIcon, Localisation, Plus } from "../../../../../../../assets/icons";
import DropdownMenu from "../../../../../../../components/DropdownMenu/DropdownMenu";
import Button from "../../../../../../../components/button";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TableRow from "../../../../../../../components/table/components/TableRow";

const DAY_LABELS = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];

const getAvailabilityStatus = (unavailableDays = []) =>
  DAY_LABELS.map((day, index) => ({ day, available: !unavailableDays.includes(index) }));

const TbodyVivier = ({ champsBody, users, setAddVivier, list, selectedId, setSelectedId, activeColumns = [], sourceOptions = [] }) => {
    const { setObjID, setInfoVivier, setSlideOverCandidatesList, setSlideOverCurrentIndex, setSlideOverMissionActions, setAdminType, setAdminTempWorkerId, setAdminUserId } = UseContext();
    const { toggleSlideOver } = useSlideOver();
    const { toggle } = useModal();
    const navigate = useNavigate();
    const location = useLocation();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropDownRef = useRef();

    const handleCheckboxChange = () => {
        const isChecked = list.includes(champsBody._id);
        setAddVivier(isChecked ? list.filter((id) => id !== champsBody._id) : [...list, champsBody._id]);
    };

    const openTempWorkerInfo = (id) => {
        const workerId = id || champsBody?._id;
        if (users?.length > 0) {
            const ids = users.map((u) => u._id);
            setSlideOverCandidatesList(ids);
            setSlideOverCurrentIndex(Math.max(ids.indexOf(workerId), 0));
        }
        setSlideOverMissionActions(null);
        setObjID(workerId);
        setSelectedId(workerId);
        toggleSlideOver('get_temp_worker');

        const params = new URLSearchParams(location.search);
        params.set('idTempWorker', workerId);
        navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    };

    useEffect(() => {
        const handler = (e) => {
            if (dropDownRef.current && !dropDownRef.current.contains(e.target)) setDropdownOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const openModal = (modalType) => {
        setInfoVivier({ listUsers: [champsBody._id] });
        toggle(modalType);
    };

    const runDropdownAction = (action) => () => {
        setDropdownOpen(false);
        action();
    };

    const dropdownItems = [
        { icon: Plus, label: 'Ajouter dans un vivier', onClick: runDropdownAction(() => openModal('vivier_add')) },
        { icon: Localisation, label: 'Modifier la localisation', onClick: runDropdownAction(() => openModal('localisation_preferences')) },
        { separator: true },
        { icon: BanIcon, label: "Exclure de l'agence", onClick: runDropdownAction(() => openModal('exclude_agency')), iconColor: '#DC2626', className: 'text-red-500' },
    ];

    const openCvDocument = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setAdminType('cv');
        setAdminTempWorkerId('');
        setAdminUserId(champsBody._id);
        toggle('ad_file_view');
    };

    const sourceName = sourceOptions.find(
        (s) => s.value === champsBody.registrationSource?.toString()
    )?.label || null;

    const renderCell = (key) => {
        switch (key) {
            case 'contact':
                return (
                    <td key="contact" className="py-5 px-2 min-w-[200px]">
                        {champsBody.phone && (
                            <CopyToClipboard text={champsBody.phone}>
                                <span className="text-sm text-gray-700">{champsBody.phone}</span>
                            </CopyToClipboard>
                        )}
                        {champsBody.email && (
                            <CopyToClipboard text={champsBody.email}>
                                <span className="text-sm text-gray-500">{champsBody.email}</span>
                            </CopyToClipboard>
                        )}
                    </td>
                );

            case 'vivier':
                return (
                    <td key="vivier" className="py-5 px-2 min-w-[120px] max-w-[180px]">
                        <p className="truncate text-sm text-gray-500">{champsBody?.viviers?.join('/ ')}</p>
                    </td>
                );

            case 'licences':
                return (
                    <td key="licences" className="py-5 px-2 min-w-[150px]">
                        <p className="text-sm text-gray-500">
                            {champsBody.licences?.length > 0
                                ? champsBody.licences.join(', ')
                                : <span className="text-gray-300">—</span>}
                        </p>
                    </td>
                );

            case 'disponibilite': {
                const days = getAvailabilityStatus(champsBody.unavailableDays ?? []);
                return (
                    <td key="disponibilite" className="py-5 px-2 min-w-[150px]">
                        <div className="flex gap-1">
                            {days.map((d, i) => (
                                <div
                                    key={i}
                                    className={`rounded w-[22px] h-[22px] flex justify-center items-center text-[10px] font-medium ${
                                        d.available
                                            ? 'text-green-600 bg-green-50'
                                            : 'text-gray-400 bg-gray-100'
                                    }`}
                                    title={d.available ? 'Disponible' : 'Non disponible'}
                                >
                                    {d.day}
                                </div>
                            ))}
                        </div>
                    </td>
                );
            }

            case 'departement':
                return (
                    <td key="departement" className="py-5 px-2 min-w-[150px]">
                        <div className="text-sm text-gray-500">
                            {champsBody.preferencesDepartment?.department || <span className="text-gray-300">—</span>}
                        </div>
                        {champsBody.preferencesDepartment?.city && (
                            <div className="text-xs text-gray-400">{champsBody.preferencesDepartment.city}</div>
                        )}
                    </td>
                );

            case 'source':
                return (
                    <td key="source" className="py-5 px-2 min-w-[150px]">
                        <p className="text-sm text-gray-500">
                            {sourceName || <span className="text-gray-300">—</span>}
                        </p>
                    </td>
                );

            case 'cv':
                return (
                    <td key="cv" className="py-5 px-2 min-w-[80px]">
                        {champsBody.cv?.updated ? (
                            <Button color="SECONDARY" onClick={openCvDocument}>
                                CV
                            </Button>
                        ) : (
                            <Button color="DISABLED">CV</Button>
                        )}
                    </td>
                );

            default:
                return <td key={key} className="py-5 px-2" />;
        }
    };

    if (champsBody?.isDeleted) return null;

    return (
        <TableRow itemId={champsBody._id} selectedId={selectedId} onClick={openTempWorkerInfo}>
            <td className="py-5 pl-4 md:pl-8 pr-2 min-w-[280px]">
                <div className="flex items-center gap-4" onClick={(e) => { e.stopPropagation(); handleCheckboxChange(); }}>
                    <input type="checkbox" checked={list?.includes(champsBody._id)} readOnly />
                    <div>
                        <div className="text-sm text-gray-900 flex gap-1 items-center">
                            <span className="truncate">{champsBody.firstname} {champsBody.lastname}</span>
                            <span className="text-gray-500 text-xs flex-shrink-0">
                                <CopyToClipboard text={champsBody.idBestt}>(N° {champsBody.idBestt})</CopyToClipboard>
                            </span>
                        </div>
                        <div className="flex gap-4">
                            {champsBody.tokenRefreshMobile && <Badge type="APP">App</Badge>}
                            {champsBody.tokenRefresh && <Badge type="WEB">Web</Badge>}
                        </div>
                        {champsBody.matchedSections?.length > 0 && (
                            <div className="flex flex-wrap gap-1 mt-0.5">
                                {champsBody.matchedSections.map((section) => (
                                    <span key={section} className="text-[10px] text-gray-400 bg-gray-50 border border-gray-100 px-1.5 py-0.5 rounded">
                                        {section}
                                    </span>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </td>

            {activeColumns.map((key) => renderCell(key))}

            <td className="py-5 pl-2 pr-4 md:pr-8">
                <div className="flex items-center gap-2 justify-end">
                    <button
                        className="w-9 h-9 flex items-center justify-center rounded hover:bg-gray-100"
                        onClick={(e) => { e.stopPropagation(); openTempWorkerInfo(champsBody?._id); }}
                    >
                        <EyeIcon wh={20} color="#374151" />
                    </button>
                    <div className="relative" ref={dropDownRef}>
                        <button
                            className="w-9 h-9 flex justify-center items-center rounded hover:bg-gray-100"
                            onClick={(e) => { e.stopPropagation(); setDropdownOpen((prev) => !prev); }}
                        >
                            <Dots w={14} h={4} color="#374151" />
                        </button>
                        {dropdownOpen && (
                            <div className="absolute right-8 -bottom-8 z-[9999]">
                                <DropdownMenu width="w-56" items={dropdownItems} />
                            </div>
                        )}
                    </div>
                </div>
            </td>
        </TableRow>
    );
};

export default TbodyVivier;
